// extracted by mini-css-extract-plugin
export default {"factsheet-container":"FactSheet_factsheet-container__Kbd5z"};